import React, { useState } from 'react';
import { Layout } from 'antd';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import styles from './AppLayout.module.css';

const { Content } = Layout;

interface AppLayoutProps {
  children: React.ReactNode;
}

const SIDEBAR_WIDTH = 240;
const SIDEBAR_COLLAPSED_WIDTH = 80;

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [sidebarDragWidth, setSidebarDragWidth] = useState<number | null>(null);

  const effectiveSidebarWidth = sidebarDragWidth ?? (sidebarCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH);

  return (
    <Layout className={styles.layout}>
      <Sidebar
        collapsed={sidebarCollapsed}
        onCollapse={setSidebarCollapsed}
        onDragWidthChange={setSidebarDragWidth}
      />
      <Layout 
        className={styles.contentLayout}
        style={{
          marginLeft: effectiveSidebarWidth,
          transition: sidebarDragWidth ? 'none' : undefined,
        }}
      >
        <Header />
        <Layout className={styles.contentPadding}>
          <Content>{children}</Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

